angular.module('bmsApp.settings').factory('MMRoomTypeSvc', function ($http, $log, $window, $q, CRUDSvc, ROOM_TYPE_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(ROOM_TYPE_API.INDEX, params);
		},
		save: function (params) {
			return CRUDSvc.post(ROOM_TYPE_API.SAVE, params);
		},
		options: function (params) {
			return CRUDSvc.get(ROOM_TYPE_API.OPTIONS, params);
		}
	}

}).constant('ROOM_TYPE_API', {
	INDEX: 'api/merrymaids/room-type/index',
	SAVE: 'api/merrymaids/room-type/save',
	OPTIONS: 'api/merrymaids/room-type/options'
});
